export default "__VITE_ASSET__Bu82be4B__"